module.exports = __webpack_public_path__ + "img/help-icon-01.80df9095.png";